import { Button, Tooltip } from '@fluentui/react-components'
import { ArrowSyncRegular } from '@fluentui/react-icons'
import { useQueryClient } from '@tanstack/react-query'
import styles from './ProjectEconomyButton.module.css'
import useProjectId from './../../../customHooks/useProjectId'

export const RefreshCacheButton = () => {
  const queryClient = useQueryClient()
  const projectId = useProjectId()

  const refetchProjectIdQueries = () => {
    queryClient.refetchQueries({
      queryKey: [projectId],
      type: 'active',
    })
  }

  const refetchNonProjectIdQueries = () => {
    const queryCache = queryClient.getQueryCache()
    const queryKeys = queryCache.getAll()?.map((cache) => cache.queryKey)

    const nonProjectIdKeys = queryKeys?.filter(
      (queryKey) => !Number(queryKey[0])
    )

    if (nonProjectIdKeys?.length > 0) {
      nonProjectIdKeys.forEach((key) => {
        queryClient.refetchQueries({
          queryKey: key,
          type: 'active',
        })
      })
    }
  }

  const handleRefresh = () => {
    refetchProjectIdQueries()
    refetchNonProjectIdQueries()
  }

  return (
    <Tooltip content="Synka projektekonomin" relationship="label">
      <Button
        className={styles.projectEconomyButton}
        icon={<ArrowSyncRegular />}
        appearance="subtle"
        onClick={handleRefresh}
      />
    </Tooltip>
  )
}
